import { deiterateAPI } from '@/js/external-js/variableModules/utils/deiterateAPI.util';

const SOC2_MATRIX_API = '/v1/soc2-matrix';

export interface SOC2ControlMatrixEntry {
  id: string;
  controlID: string;
  suggestedAssurance: string[];
}

export const listSOC2ControlMatrix = async (tenancyId: string): Promise<SOC2ControlMatrixEntry[]> => {
  if (!tenancyId) return [];

  try {
    const response = await deiterateAPI.GET(SOC2_MATRIX_API, {
      mode: 'cors',
      backend: 'thalassa',
    });

    if (response.statusCode === 200 && response.entries) {
      return response.entries;
    }

    return [];
  } catch (error) {
    console.error('[SOC2ControlMatrixService] Failed to load matrix:', error);
    throw error;
  }
};

export const getSOC2ControlById = async (tenancyId: string, controlId: string): Promise<SOC2ControlMatrixEntry | null> => {
  if (!tenancyId || !controlId) return null;

  try {
    const response = await deiterateAPI.GET(`${SOC2_MATRIX_API}/${controlId}`, {
      mode: 'cors',
      backend: 'thalassa',
    });

    if (response.statusCode === 200 && response.entry) {
      return response.entry;
    }

    return null;
  } catch (error) {
    console.error(`[SOC2ControlMatrixService] Failed to fetch control ${controlId}:`, error);
    throw error;
  }
};

export default {
  listSOC2ControlMatrix,
  getSOC2ControlById,
};
